import { render, staticRenderFns } from "./pin-info.vue?vue&type=template&id=d4ddf380&scoped=true&"
import script from "./pin-info.vue?vue&type=script&lang=js&"
export * from "./pin-info.vue?vue&type=script&lang=js&"
import style0 from "./pin-info.vue?vue&type=style&index=0&id=d4ddf380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ddf380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
